export const SHAREABLE_STRINGS = {
  referNow: 'Refer Now',
  learnMore: 'Learn More',
  copyLink: 'Copy Link',
};
